// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"c3f82861","240":"8301dc4c","595":"fc56ee70","681":"6d747742"}[chunkId] + ".css";
};